import React from "react";
import { useOrganisationContext } from "../hooks";

export const withSelectedOrganisation = () => (BaseComponent) => (props) => {
  const { selectedOrganisation } = useOrganisationContext();
  return (
    <BaseComponent {...props} selectedOrganisation={selectedOrganisation} />
  );
};
